module.exports = __webpack_public_path__ + "img/Eritrea.b0e139fe.png";